import { createSidecarMedium } from 'use-sidecar';
export var effectCar = createSidecarMedium();